import * as colors from 'components/common/colorConstants';
import styled from 'styled-components';

export const TreeUL = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  font-family: 'Source Code Pro', monospace;
  font-size: 11px;
`;

export const TreeLI = styled.li`
  margin-top: 2px;
  margin-bottom: 2px;
  position: relative;
  padding-left: 8px;
  font-family: 'Source Code Pro', monospace;
  text-wrap: wrap;
`;

export const TreeExpandArrow = styled.div`
  position: absolute;
  top: 8px;
  left: 4px;
  transform: translateY(-50%) rotate(${({ collapsed }) => (collapsed ? '180' : '270')}deg);
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-right: 8px solid ${colors.red2};
  cursor: pointer;

  && {
    border-color: transparent ${colors.red2} transparent transparent;
  }
`;

export const TreeKeyName = styled.div`
  display: flex;
  gap: 4px;
  align-items: start;
  margin-left: 12px;

  border: none;
  background-color: transparent;
  font: inherit;
  cursor: ${({ hasChildren }) => (hasChildren ? 'pointer' : 'default')};
  color: ${colors.red2};
  font-family: 'Source Code Pro', monospace;
`;

export const TreeKey = styled.div`
  border: none;
  font: inherit;
  color: ${colors.red2};

  // Temporary while we wait for updated designs.
  width: 100%;
  overflow-wrap: anywhere;
`;

export const TreeValue = styled.span`
  font-family: 'Source Code Pro', monospace;
  color: ${colors.black4};
  align-self: center;

  // Temporary while we wait for updated designs.
  width: 50%;
  overflow-wrap: anywhere;
`;

export const TreeWrapper = styled.div`
  @import url('https://fonts.googleapis.com/css2?family=Source+Code+Pro&display=swap');
  width: 100%;
  min-height: 100px;
  max-height: 500px;
  overflow: auto;
  white-space: nowrap;
  font-family: 'Source Code Pro', monospace;
  /* font-size: 12px; */
  background-color: ${colors.baseText};
  padding: 10px;
  border-radius: 14px;
`;

export const ThemeStrokeSVG = styled.svg`
  stroke: ${colors.baseText};
  cursor: pointer;
  width: 12px;
  height: 12px;
  &:active {
    width: 10px;
    height: 10px;
    margin-left: 1px;
    margin-right: 1px;
  }
`;
